import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  DirectionalDrillingWidgetEntity,
  TDirectionalDrillingSerializedInternalState,
} from 'src/pages/dashboard/features/directional-drilling-widget/DirectionalDrillingWidget.entity';

export function serializeDirectionalDrillingWidget(widget: DirectionalDrillingWidgetEntity): TSerializedWidget {
  const internalState: TDirectionalDrillingSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: {
      wellboreId: widget.stateParams.wellboreId,
      gravityToolParams: widget.stateParams.gravityToolParams,
      magneticToolParams: widget.stateParams.magneticToolParams,
      isPaused: widget.stateParams.isPaused,
      is360: widget.stateParams.is360,
    },
  };

  return {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
